import { TypedDocumentNode, gql } from '@apollo/client';

import useMutation from '@sorare/core/src/hooks/graphql/useMutation';
import { useGetInteractionContext } from '@sorare/core/src/hooks/useGetInteractionContext';

import {
  CreateCompetitionSubscriptionMutation,
  CreateCompetitionSubscriptionMutationVariables,
} from './__generated__/useCreateCompetitionSubscription.graphql';

const CREATE_COMPETITION_SUBSCRIPTION_MUTATION = gql`
  mutation CreateCompetitionSubscriptionMutation(
    $interactionContext: String
    $slug: String!
  ) {
    createSubscription(
      input: {
        interactionContext: $interactionContext
        subscribable: { slug: $slug, type: "Competition" }
      }
    ) {
      subscription {
        slug
        anySubscribable {
          slug
          currentUserSubscription {
            slug
          }
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<
  CreateCompetitionSubscriptionMutation,
  CreateCompetitionSubscriptionMutationVariables
>;

export const useCreateCompetitionSubscription = () => {
  const [subscribe] = useMutation(CREATE_COMPETITION_SUBSCRIPTION_MUTATION);
  const interactionContext = useGetInteractionContext()();

  return [
    async (slug: string) => {
      return subscribe({
        variables: {
          slug,
          interactionContext,
        },
        optimisticResponse: {
          createSubscription: {
            subscription: {
              slug: `temp-${slug}`,
              anySubscribable: {
                slug,
                currentUserSubscription: {
                  slug: `temp-${slug}`,
                  __typename: 'EmailSubscription',
                },
                __typename: 'Competition',
              },
              __typename: 'EmailSubscription',
            },
            errors: [],
            __typename: 'createSubscriptionPayload',
          },
        },
      });
    },
  ];
};
